<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" label-width="100px" class="demo-form-inline ">
        <el-form-item label="供应商名称" prop="supId">
          <el-select v-model="form.supId" @change="change" clearable filterable placeholder="请选择供应商名称">
            <el-option :label="item.supName" :value="item.supId" v-for="(item, $index) in form.supData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户名称" prop="accountId">
          <el-select v-model="form.accountId" clearable filterable placeholder="请选择账户名称">
            <el-option :label="item.supAccountName" :value="item.supAccountId" v-for="(item, $index) in form.accountData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值日期" prop="date">
          <el-date-picker
            v-model="form.date"
            type="date"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="充值类型" prop="type">
          <el-select v-model="form.type" clearable filterable placeholder="请选择充值类型">
            <el-option label="预充值" value="0" ></el-option>
            <el-option label="补偿款" value="1" ></el-option>
            <el-option label="扣减" value="2" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作人" prop="operator">
          <el-input v-model="form.operator" clearable placeholder="请输入操作人"></el-input>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <!-- <el-table-column
          label="序号"
          type="index"
          >
        </el-table-column> -->
        <el-table-column
          label="充值流水号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span class="link" @click="handleEdit(scope.$index, scope.row)">{{ scope.row.recordId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="供应商全称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.supName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.supAccountName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户编号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.supAccountId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="充值金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.rechargeAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="充值后余额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.rechargeBalance }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="累计充值金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.rechargeTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="充值时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="充值类型"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.rechargeType === '1' ? '补偿款' : scope.row.rechargeType === '0' ? '预充值' : '扣减' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付方式"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.payMethod === '1' ? '网银转账' : '垫付' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作人"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.operator }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column width="90" fixed="right" label="操作" >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog title="供应商充值详情" width="850px" center :modal-append-to-body='false' :visible.sync="cusDialog">
      <el-form :model="detailForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商名称:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.supName" ></el-input>
              <!-- <span>{{detailForm.supName}}</span> -->
            </el-form-item>
            <el-form-item label="账号名称:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.supAccountName" ></el-input>
              <!-- <span>{{detailForm.supAccountName}}</span> -->
            </el-form-item>
            <el-form-item label="账号:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.supAccountId" ></el-input>
              <!-- <span>{{detailForm.supAccountId}}</span> -->
            </el-form-item>
            <el-form-item label="充值金额:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.rechargeAmount" ></el-input>
              <!-- <span>{{detailForm.rechargeAmount}}</span> -->
            </el-form-item>
            <el-form-item label="充值后余额:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.rechargeBalance" ></el-input>
              <!-- <span>{{detailForm.rechargeBalance}}</span> -->
            </el-form-item>
            <el-form-item label="累计充值金额:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.rechargeAmountTotal" ></el-input>
              <!-- <span>{{detailForm.rechargeAmountTotal}}</span> -->
            </el-form-item>
            <el-form-item label="支付说明:" >
              <span>{{detailForm.rechargeDesc }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.operator" ></el-input>
              <!-- <span>{{detailForm.operator}}</span> -->
            </el-form-item>
            <el-form-item label="充值时间:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.createTime" ></el-input>
              <!-- <span>{{detailForm.createTime}}</span> -->
            </el-form-item>
            <el-form-item label="充值类型:" >
              <span>{{detailForm.rechargeType === '1' ? '补偿款' : detailForm.rechargeType === '0' ? '预充值' : '扣减' }}</span>
            </el-form-item>
            <el-form-item label="是否包年:" >
              <span>{{detailForm.yearFlag === '1' ? '是' : '否' }}</span>
            </el-form-item>
            <el-form-item label="支付方式:" >
              <span>{{detailForm.payMethod === '1' ? '网银转账' : '垫付' }}</span>
            </el-form-item>
            <el-form-item label="充值凭证:" >
              <img class="img" :src="detailForm.rechargeProof" alt="">
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'supplierDetail',
  data () {
    return {
      form: {
        supId: '',
        supData: [],
        type: '',
        accountId: '',
        accountData: [],
        operator: '',
        date: ''
      },
      cusDialog: false,
      tableData: [],
      tooltip: true,
      currentPage: 1,
      page: 10,
      total: 0,
      detailForm: {
        createTime: '',
        operator: '',
        supAccountId: '',
        supAccountName: '',
        supName: '',
        payMethod: '',
        rechargeAmount: '',
        rechargeAmountTotal: '',
        rechargeBalance: '',
        rechargeType: '',
        rechargeDesc: '',
        rechargeUrl: '',
        yearFlag: ''
      }
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.supId = ''
      this.form.accountId = ''
      this.form.operator = ''
      this.form.date = ''
      this.form.type = ''
      this.form.accountData = []
    },
    handleEdit (index, row) {
      let id = row.recordId
      let _this = this
      this.$axios({
        url: _this.$API.rechargeManagement.queryRechargeRecordById,
        method: 'get',
        params: { id: id }
      }).then((response) => {
        if (response.data.resData) {
          let op = response.data.resData
          _this.detailForm.createTime = op.createTime
          _this.detailForm.operator = op.operator
          _this.detailForm.supAccountId = op.supAccountId
          _this.detailForm.supAccountName = op.supAccountName
          _this.detailForm.supName = op.supName
          _this.detailForm.payMethod = op.payMethod
          _this.detailForm.rechargeAmount = op.rechargeAmount
          _this.detailForm.rechargeAmountTotal = op.rechargeAmountTotal
          _this.detailForm.rechargeBalance = op.rechargeBalance
          _this.detailForm.rechargeDesc = op.rechargeDesc
          _this.detailForm.rechargeType = op.rechargeType
          _this.detailForm.rechargeProof = op.rechargeProof
          _this.detailForm.yearFlag = op.yearFlag
          _this.cusDialog = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    change (val) {
      let _this = this
      if (val) {
        this.$axios({ // 请求账户
          url: _this.$API.rechargeManagement.queryAccStatusBySupId,
          method: 'get',
          params: { supId: val }
        }).then((response) => {
          console.log(response.data.resData)
          if (!response.data.resData) return
          _this.form.accountData = response.data.resData
        })
      } else {
        this.form.accountData = []
      }
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    initData () {
      let _this = this
      this.$axios({
        url: _this.$API.rechargeManagement.querySupInfoAll,
        method: 'get'
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.supData = response.data.resData
      }).catch((err) => {
        console.log(err)
      })
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.supId = this.form.supId
      op.supAccountId = this.form.accountId
      op.rechargeDate = this.form.date
      op.rechargeType = this.form.type
      op.operator = this.form.operator
      this.$axios({
        url: _this.$API.rechargeManagement.queryRecordListByPage,
        method: 'post',
        data: op
      }).then((response) => {
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/rechargeManagement/supplierDetail.vue